import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_COMPANY_SELECTOR', LOG_LEVELS.DEBUG);

export class SingleCompanySelector extends React.Component {
  selectionCheckedHandlerFactory(fieldName) {
    return (event) => {
      log.debug('selectionCheckedHandlerFactory(%s): %s, ', fieldName, event);
      log.debug(
        'selectionCheckedHandlerFactory(%s): oldValue: %s, newValue: %s  ',
        fieldName,
        this.props[fieldName],
        event.detail.item.id,
        event.detail.item.value
      );
      let selection = {};
      selection[fieldName] = event.detail.item.value !== '' ? event.detail.item.value : undefined;
      this.props.selectionHandler(selection);
    };
  }

  render() {
    log.debug('render(): ', this.props);

    let companyOptions = [];

    if(!this.props.hideDefaultValue){
      let defaultOptionText =
      typeof this.props.selectValueLanguageStringKey === 'string'
        ? LANGUAGES_CONTROLLER.format(this.props.languages, this.props.selectValueLanguageStringKey)
        : LANGUAGES_CONTROLLER.format(this.props.languages, 'global_SelectCompany');
      const defaultItem = { label: defaultOptionText, value: 'All' };
      companyOptions.push(defaultItem);
    }
    
    const options = this.props.companyList.map((company) => {
      const codeOrId = this.props.valueCompanyCode ? company.code : company.id.toString();
      return {
        value: codeOrId,
        label: `${company.code} - ${company.name}`,
        selected: this.props.selectedCompanyId?.toString() === codeOrId.toString(), // companyId can be string or no, depending on how set in consuming component
      };
    }, this);

    companyOptions.push(...options);

    if(Array.isArray(this.props.customOptions) && this.props.customOptions.length > 0){
      this.props.customOptions.map((opt) => {
        const extraItem = { 
          label: opt.body ?? '',
          value: opt?.value ?? '',
          selected: this.props.selectedCompanyId?.toString() === opt?.value.toString()
        };
        companyOptions.push(extraItem); 
      }, this)
    }
    
    const disabled = this.props.extraProps.disabled ? true : false;
    const className = this.props.extraProps.className;

    return (
      <div data-test="component-single-company-selector" className={className}>
        <SSelect
          inputId="company-single-select"
          name="companies"
          onS-select={this.selectionCheckedHandlerFactory(this.props.fieldName).bind(this)}
          optionsList={companyOptions || []}
          multiple={false}
          showSelectionCount={false}
          disabled={disabled}
        />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state);
  const defaultCompanyList = (state.companies && state.companies.data) || [];
  return {
    languages: state.languages,
    companyList: props.companyList || defaultCompanyList,
  };
}


SingleCompanySelector.defaultProps = {
  valueCompanyCode: false,
  customOptions: [],
  extraProps: {},
};

export default connect(mapStateToProps)(SingleCompanySelector);
